import {
  CuraButton,
  CuraButtonOutline,
  CuraHeading,
  CuraIcon,
  CuraLabel,
  CuraModal,
  CuraParagraph
} from '@rededor/cura-react'
import * as S from './styles'
import { formatBirthDate } from '@/utils/helpers/formatBirthdate'
import { getAccessToken } from '@/utils/helpers/storageHelpers'
import { Show } from '../Show'

type RecoveryData = {
  location?: {
    id: string
    name: string
  }
  product?: {
    id: string | number
    name: string
  }
  doctor?: {
    id: number
    name: string
  }
  payment?: {
    idPlan: number
    idCarrier: number
    healthCarrier: string
    healthPlan: string
    isPrivate: boolean
  }
  patient?: {
    birthDate: string
    gender: string
    id: string
  }
}

type CartRecoveryModalProps = {
  open: boolean
  recoveryData: RecoveryData | null
  onAccept: () => void
  onReject: (type: 'close' | 'reject') => void
}

export const CartRecoveryModal = ({
  open,
  recoveryData,
  onAccept,
  onReject
}: CartRecoveryModalProps) => {
  const formatGender = (gender?: string) => {
    if (gender === 'F') return 'Feminino'
    if (gender === 'M') return 'Masculino'
    return '-'
  }

  const isLogged = Boolean(getAccessToken())

  return (
    <>
      <CuraModal
        open={open}
        onModalClose={() => onReject('close')}
        canClose={false}
      >
        <S.ContentModal>
          <S.WrapperText>
            <CuraIcon name="calendar" size={20} color="neutral-black" />
            <CuraHeading
              size="small"
              color="neutral-black"
              marginBlock="8px"
              weight="bold"
            >
              Continue de onde parou.
            </CuraHeading>
          </S.WrapperText>

          <S.Divider />

          {recoveryData?.doctor ? (
            <>
              <S.Field>
                <CuraLabel color="neutral-dark" size="xsmall">
                  Médico
                </CuraLabel>
                <CuraParagraph
                  color="neutral-black"
                  size="medium"
                  marginBlock="8px !important"
                >
                  {recoveryData.doctor.name}
                </CuraParagraph>
                <CuraParagraph
                  color="neutral-black"
                  size="medium"
                  marginBlock="8px !important"
                >
                  {recoveryData.product?.name}
                </CuraParagraph>
              </S.Field>

              <S.DotDivider />
            </>
          ) : (
            recoveryData?.product?.name && (
              <>
                <S.Field>
                  <CuraLabel color="neutral-dark" size="xsmall">
                    Especialidade
                  </CuraLabel>
                  <CuraParagraph
                    color="neutral-black"
                    size="medium"
                    marginBlock="8px !important"
                  >
                    {recoveryData.product.name}
                  </CuraParagraph>
                </S.Field>

                <S.DotDivider />
              </>
            )
          )}

          {recoveryData?.location?.name && (
            <>
              <S.Field>
                <CuraLabel color="neutral-dark" size="xsmall">
                  Local
                </CuraLabel>
                <CuraParagraph
                  color="neutral-black"
                  size="medium"
                  marginBlock="8px !important"
                >
                  {recoveryData.location.name}
                </CuraParagraph>
              </S.Field>
              <S.DotDivider />
            </>
          )}

          <Show when={!isLogged}>
            {(recoveryData?.patient?.birthDate ||
              recoveryData?.patient?.gender) && (
              <>
                <S.TwoFields>
                  {recoveryData.patient.birthDate && (
                    <S.Field>
                      <CuraLabel color="neutral-dark" size="xsmall">
                        Data de nascimento:
                      </CuraLabel>
                      <CuraParagraph
                        color="neutral-black"
                        size="medium"
                        marginBlock="8px !important"
                      >
                        {formatBirthDate(recoveryData.patient.birthDate)}
                      </CuraParagraph>
                    </S.Field>
                  )}

                  {recoveryData.patient.gender && (
                    <S.Field style={{ marginRight: '20px' }}>
                      <CuraLabel color="neutral-dark" size="xsmall">
                        Sexo biológico:
                      </CuraLabel>
                      <CuraParagraph
                        color="neutral-black"
                        size="medium"
                        marginBlock="8px !important"
                      >
                        {formatGender(recoveryData.patient.gender)}
                      </CuraParagraph>
                    </S.Field>
                  )}
                </S.TwoFields>
                <S.DotDivider />
              </>
            )}
          </Show>
          {recoveryData?.payment && (
            <>
              {recoveryData.payment.isPrivate ? (
                <>
                  <S.Field>
                    <CuraLabel color="neutral-dark" size="xsmall">
                      Pagamento:
                    </CuraLabel>
                    <CuraParagraph
                      color="neutral-black"
                      size="medium"
                      marginBlock="8px !important"
                    >
                      Particular
                    </CuraParagraph>
                  </S.Field>
                </>
              ) : (
                <>
                  <S.Field>
                    <CuraLabel color="neutral-dark" size="xsmall">
                      Convênio:
                    </CuraLabel>
                    <CuraParagraph
                      color="neutral-black"
                      size="medium"
                      marginBlock="8px !important"
                    >
                      {recoveryData.payment.healthCarrier}
                    </CuraParagraph>
                  </S.Field>

                  <S.FieldPayment>
                    <CuraLabel color="neutral-dark" size="xsmall">
                      Plano:
                    </CuraLabel>
                    <CuraParagraph
                      color="neutral-black"
                      size="medium"
                      marginBlock="8px !important"
                    >
                      {recoveryData.payment.healthPlan}
                    </CuraParagraph>
                  </S.FieldPayment>
                </>
              )}

              <S.DotDivider />
            </>
          )}

          <S.ButtonsRow>
            <CuraButtonOutline
              color="primary"
              size="medium"
              fontColor="dark"
              background="light"
              onClick={() => onReject('reject')}
            >
              NÃO OBRIGADO
            </CuraButtonOutline>

            <CuraButton
              color="primary-base"
              size="medium"
              fontColor="light"
              onClick={onAccept}
            >
              SIM CONTINUE
            </CuraButton>
          </S.ButtonsRow>
        </S.ContentModal>
      </CuraModal>
    </>
  )
}
